import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function PurchasesRefresh({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 24 24" width={size} {...props}>
      <Path
        d="M15.187 9.87627H20.5001V3.50128"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <Path
        d="M20.2324 9.87616C19.7538 8.02177 18.6629 6.38333 17.1366 5.22637C15.6102 4.06941 13.7379 3.46175 11.8229 3.50187C9.90798 3.54199 8.06271 4.22754 6.58617 5.44741C5.10963 6.66728 4.08837 8.34998 3.6879 10.2228C3.28743 12.0956 3.53122 14.0487 4.37977 15.7657C5.22832 17.4826 6.63189 18.8627 8.36299 19.6823C10.0941 20.5019 12.0513 20.7129 13.9173 20.2812C15.7834 19.8495 17.449 18.8003 18.6441 17.3037"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </Svg>
  );
});
